"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslationStore = exports.translationStore = exports.TranslationStore = void 0;
const BaseStore_1 = require("@/store/BaseStore");
const __1 = __importDefault(require(".."));
const tsyringe_1 = require("tsyringe");
const DEFAULT_LANGUAGE = "en";
const LOCALSTORAGE_KEY = "meteomars_translation_state";
let TranslationStore = class TranslationStore extends BaseStore_1.BaseStore {
    constructor() {
        const state = loadState();
        super(state || {
            language: getNavigatorLanguage() || DEFAULT_LANGUAGE,
        });
        __1.default.changeLanguage(this.getState().language);
    }
    setLanguage(language) {
        this.setState((s) => (Object.assign(Object.assign({}, s), { language })));
        __1.default.changeLanguage(language);
        saveState(this.getState());
    }
};
exports.TranslationStore = TranslationStore;
exports.TranslationStore = TranslationStore = __decorate([
    (0, tsyringe_1.singleton)(),
    __metadata("design:paramtypes", [])
], TranslationStore);
function saveState(data) {
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(data));
}
function loadState() {
    let data = null;
    try {
        data = localStorage.getItem(LOCALSTORAGE_KEY);
        if (!data)
            return null;
        return JSON.parse(data);
    }
    catch (err) {
        console.error("Error while loading translation state from local storage. Data: " + data);
        return null;
    }
}
function getNavigatorLanguage() {
    const match = navigator.language.match(/^([a-zA-Z]+)/);
    if (match == null)
        return null;
    return match[0];
}
exports.translationStore = tsyringe_1.container.resolve(TranslationStore);
exports.useTranslationStore = (() => {
    return exports.translationStore.useState.bind(exports.translationStore);
})();
